import { createRouter, createWebHistory } from 'vue-router'
import { useAdminStore } from '../stores/admin.js'

const routes = [
  {
    path: '/',
    component: () => import('../layouts/BaseLayout.vue'),
    children: [
      { path: '',           name: 'acasa',          component: () => import('../views/AcasaView.vue') },
      { path: 'produse',    name: 'produse',         component: () => import('@/views/ProduseView.vue') },
      { path: 'produse/:id', name: 'produs',         component: () => import('@/views/ProdusView.vue') },
      { path: 'comanda',    name: 'comanda',          component: () => import('@/views/ComandaView.vue') },
      { path: 'comanda/:cod', name: 'tracking',      component: () => import('@/views/TrackingView.vue') },
      { path: 'comenzile-mele', name: 'comenzile-mele', component: () => import('@/views/ComenzileMeleView.vue') },
      { path: 'despre-noi', name: 'despre-noi',      component: () => import('@/views/DespreNoiView.vue') },
      { path: 'contact',    name: 'contact',          component: () => import('@/views/ContactView.vue') },
      { path: 'politica-confidentialitate', name: 'politica',  component: () => import('@/views/PoliticaConfidentialitateView.vue') },
      { path: 'termeni-si-conditii', name: 'termeni',      component: () => import('@/views/TermeniConditiiView.vue') }
    ]
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('../views/admin/AdminLogin.vue')
  },

  // Admin panel (cu layout admin, protejat)
  {
    path: '/admin',
    component: () => import('../layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '',          name: 'admin',           component: () => import('../views/admin/AdminDashboard.vue') },
      { path: 'comenzi',   name: 'admin-comenzi',   component: () => import('../views/admin/AdminComenzi.vue') },
      { path: 'comenzi/:id', name: 'admin-comanda', component: () => import('../views/admin/AdminComanda.vue') },
      { path: 'produse',   name: 'admin-produse',   component: () => import('../views/admin/AdminProduse.vue') },
      { path: 'categorii', name: 'admin-categorii', component: () => import('../views/admin/AdminCategorii.vue') },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0, behavior: 'smooth' }
  }
})

// Guard autentificare admin
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const admin = useAdminStore()
    if (!admin.esteAutentificat) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
